<section>
  <div flex fxLayout="column" fxLayoutAlign="center">
    <strong>Empfänger</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">
      {{ this.data.actionInfo.recipients }}
    </p>
    <strong>Betreff der E-Mail</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">
      {{ this.data.actionInfo.subject }}
    </p>
    <div *ngIf="currentFormApprove">
      <form [formGroup]="currentFormApprove">
        <form-row *ngIf="model.gridRegistrationType != gridRegistrationType.ChangeMeteringConcept">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Netzanschlusspunkt</mat-label>
            <input matInput type="text" formControlName="gridConnectionPoint" />
          </mat-form-field>
        </form-row>

        <form-row *ngIf="dataShareService.tenantConfig.gridRegistration.showAssignedTransformerStation">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>zugeordnete Station</mat-label>
            <input matInput type="text" formControlName="assignedTransformerStation" />
          </mat-form-field>
        </form-row>

        <form-row *ngIf="model.gridRegistrationType != gridRegistrationType.ChangeMeteringConcept">
          <mat-form-field appearance="outline">
            <mat-label>Spannungsebene</mat-label>
            <mat-select formControlName="voltageLevel">
              <mat-option *ngFor="let ele of metaService.voltageLevels$ | async" [value]="ele.value">
                {{ ele.displayName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form-row>

        <div
          *ngIf="
            model.gridRegistrationType != gridRegistrationType.Feeder &&
            model.gridRegistrationType != gridRegistrationType.ChangeMeteringConcept
          ">
          <div class="wrapper" style="margin-bottom: 1.5rem">
            <div class="col" fxFlex="100">
              <mat-checkbox formControlName="loadManagementRequired" (change)="checkboxChanged($event)">
                Lastmanagement nötig
              </mat-checkbox>
            </div>
          </div>
          <div *ngIf="currentFormApprove.get('loadManagementRequired').value">
            <section>
              <div>Maximale Netzentnahmeleistung {{ maxExtractionPower }}</div>
            </section>
            <form-row>
              <mat-form-field appearance="outline" name="extractionNetworkPowerAuthorized" fxFlex>
                <mat-label>Genehmigte Netzentnahmeleistung</mat-label>
                <input matInput type="number" formControlName="extractionNetworkPowerAuthorized" />
              </mat-form-field>
            </form-row>
          </div>
        </div>

        <div
          *ngIf="
            model.gridRegistrationType === gridRegistrationType.Feeder ||
            (model.gridRegistrationType === gridRegistrationType.Storage &&
              !!model.storages.length &&
              hasProduction(model.storages[0].storageOperationType))
          ">
          <div>
            <section>
              <form-row>
                <mat-form-field appearance="outline">
                  <mat-label>Anschlussverordnung</mat-label>
                  <mat-select formControlName="feederConnectionStandard">
                    <mat-option
                      *ngFor="let ele of metaService.feederConnectionStandards$ | async"
                      [value]="ele.value">
                      {{ ele.displayName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </form-row>

              <form-row>
                <mat-form-field appearance="outline">
                  <mat-label>Verfahren zur Blindleistungsbereitstellung</mat-label>
                  <mat-select formControlName="reactivePowerProvisioningMethod">
                    <mat-option
                      *ngFor="let ele of metaService.reactivePowerProvisioningMethods$ | async"
                      [value]="ele.value">
                      {{ ele.displayName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </form-row>

              <ng-container *ngIf="!(isQUStandardCurve$ | async)">
                <form-row>
                  <mat-form-field appearance="outline" fxFlex>
                    <mat-label>fester Verschiebungsfaktor cos &phi;</mat-label>
                    <input matInput type="number" formControlName="cosPhi" />
                  </mat-form-field>
                </form-row>
              </ng-container>
            </section>
          </div>
        </div>
        <section>
          <mat-form-field appearance="outline" style="margin-bottom: 0.5rem" fxFlex>
            <mat-label>Kommentar zur Freigabe</mat-label>
            <textarea
              matInput
              type="text"
              rows="3"
              maxlength="255"
              formControlName="approvalComment"></textarea>
          </mat-form-field>
        </section>
      </form>
    </div>
  </div>
  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" id="modal-confirm-button" (click)="confirm()">Speichern</button>
  </div>
</section>
